export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Revoking immediately can race Chrome's read of the blob for its download-
  // complete popup, so the file saves but the notification silently never shows.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const parseContentDispositionFilename = (
  header: string | null,
): string | null => {
  if (!header) return null;
  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (utf8Match) return decodeURIComponent(utf8Match[1]);
  const quotedMatch = /filename="([^"]+)"/i.exec(header);
  if (quotedMatch) return quotedMatch[1];
  const bareMatch = /filename=([^;]+)/i.exec(header);
  return bareMatch ? bareMatch[1].trim() : null;
};

const sanitizeFilePart = (part: string | undefined, fallback: string): string => {
  const value = (part ?? "").trim() || fallback;
  return value.replace(/[\\/:*?"<>|]/g, "-").slice(0, 80);
};

export const buildFallbackExportFilename = (
  parts: (string | undefined)[],
  extension: "csv" | "xlsx",
): string => {
  const fallbacks = ["Dashboard", "Tab", "Visualization"];
  const named = parts.map((part, index) =>
    sanitizeFilePart(part, fallbacks[index] ?? "Export"),
  );
  const timestamp = new Date()
    .toISOString()
    .replace(/[:.]/g, "-")
    .replace("T", " ")
    .replace("Z", "");
  return `${[...named, timestamp].join(" - ")}.${extension}`;
};
